/* eslint-disable no-underscore-dangle */
/* eslint-disable no-multi-assign */
// SiftScience fraud detection JS
// https://sift.com/developers/docs/curl/apis-overview
// Script initialized on window in `pages/_.app.js`

import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export default function siftPageView(sessionId, userId = '') {
  const sift = (window._sift = window._sift || []);

  sift.push(['_setAccount', publicRuntimeConfig.siftScienceApiKey]);
  sift.push(['_setUserId', userId]);
  sift.push(['_setSessionId', sessionId]);
  sift.push(['_trackPageview']);
}
